import React from 'react';

import styles from './styles/question-box.module.css';

import {ReactComponent as Abnormal} from '../../assets/bot/abnormal-circle.svg';
import {ReactComponent as Analysis} from '../../assets/bot/analysis-circle.svg';
import {ReactComponent as Database} from '../../assets/bot/database-circle.svg';
import {ReactComponent as Default} from '../../assets/bot/default-circle.svg';
import {ReactComponent as Document} from '../../assets/bot/document-circle.svg';
import {ReactComponent as Email} from '../../assets/bot/email-circle.svg';
import {ReactComponent as FAQ} from '../../assets/bot/faq-circle.svg';
import {ReactComponent as REPORT} from '../../assets/bot/report-circle.svg';

export default function QuestionBox({ botType, question }) {
    const getBotIcon = (botType) => {
        if (botType === 'ABNORMAL') return <Abnormal />;
        if (botType === 'ANALYSIS') return <Analysis />;
        if (botType === 'DATABASE') return <Database />;
        if (botType === 'DOCUMENT') return <Document />;
        if (botType === 'EMAIL') return <Email />;
        if (botType === 'FAQ') return <FAQ />;
        if (botType === 'REPORT') return <REPORT />;
    
        return <Default />;
    };

    return (
        <div className={styles.wrapper}>
            {getBotIcon(botType)}
            <p>{question}</p>
        </div>
    );
}
